class DefaultTabs {
  constructor() {
    
    this.wrapper = document.querySelectorAll('.default-tabs');

    // console.log(document.querySelector('.default-tabs'));
    // console.log(this.wrapper);
    
    if (!this.wrapper) {
      return false;
    }

    this.wrapper.forEach((item) => {
      new DefaultTab(item);
    });

  }
}

class DefaultTab {
  constructor(tabWrapper) {

    this.navigationList = tabWrapper.querySelector('.default-tabs-navigation');
    this.contentList = tabWrapper.querySelector('.default-tabs-content'); 
    this.displayTab = this.displayTab.bind(this);

    this.displayTab(0);

    this.navigationList.querySelectorAll('a').forEach((item, index) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        this.displayTab(index);
      });
    });
  }

  displayTab(index) {
    this.navigationList.querySelectorAll('a').forEach((item) => {
      item.classList.remove('active');
    });

    this.contentList.querySelectorAll('.tab-item').forEach((item) => {
      item.classList.remove('active');
    });

    this.navigationList.querySelectorAll('a')[index].classList.add('active');
    this.contentList.querySelectorAll('.tab-item')[index].classList.add('active');
  }

}

export default DefaultTabs;